import moment from 'moment';

// eslint-disable-next-line import/prefer-default-export
export function formatMonthDate(date) {
  return moment(date).format('MMMM D');
}
